import classNames from 'classnames';
import t__default from 'react';
import { s as styleInject } from '../style-inject.es-e7b07dd7.js';
import { BUTTON_SIZE } from '../consts.js';

var css_248z = ".LPztG,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.X07iu,.ZFe4o{color:var(--ricos-settings-buttons-text-color,#fff);font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial);font-size:16px;width:100%}[dir] .X07iu,[dir] .ZFe4o{border:1px solid var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));border-radius:var(--ricos-settings-buttons-border-radius,0);cursor:pointer}.RuLf5.X07iu,.RuLf5.ZFe4o{text-decoration:underline}[dir] .RuLf5.X07iu,[dir] .RuLf5.ZFe4o{border:none}.bZxAX.X07iu,.bZxAX.ZFe4o{color:var(--ricos-fallback-color,#000);width:50px}[dir] .bZxAX.X07iu,[dir] .bZxAX.ZFe4o{background:transparent;border:none;padding:0}[dir] .X07iu:disabled,[dir] .ZFe4o:disabled{background-color:var(--ricos-settings-disabled-background-color,rgba(0,0,0,.4))}.X07iu{color:#fff}[dir] .X07iu{background-color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .X07iu:hover:not([disabled]){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.8)}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .X07iu:hover:not([disabled]){background-color:transparent}}}@container (width < 640px){[dir] .X07iu:hover:not([disabled]){background-color:transparent}}.X07iu:disabled{color:var(--ricos-settings-buttons-text-color,hsla(0,0%,100%,.6))}[dir] .X07iu:disabled{border:none;cursor:auto}.X07iu.bZxAX,.ZFe4o{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .ZFe4o{background:#fff}.ZFe4o:active,.ZFe4o:hover{color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.6)}[dir] .ZFe4o:active,[dir] .ZFe4o:hover{border-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.6)}.ZFe4o:disabled{color:rgba(0,0,0,.4)}.ujUJO{font-size:14px;height:32px}._3hiHF{height:36px}.CeCP-{height:40px}.FMu-j{height:48px}";
var styles = {"fontElementMap":"LPztG","button_secondary":"ZFe4o","button_primary":"X07iu","borderLess":"RuLf5","mobile":"bZxAX","tiny":"ujUJO","small":"_3hiHF","medium":"CeCP-","large":"FMu-j"};
styleInject(css_248z);

const Button = ({
  onClick,
  dataHook,
  ariaLabel,
  size = BUTTON_SIZE.small,
  children,
  tabIndex = 0,
  disabled = false,
  secondary = false,
  borderless = false,
  isMobile = false,
  style
}) => {
  const buttonStyle = secondary ? styles.button_secondary : styles.button_primary;
  return /* @__PURE__ */ t__default.createElement(
    "button",
    {
      "aria-label": ariaLabel,
      "data-hook": dataHook,
      onClick,
      tabIndex,
      disabled,
      className: classNames(buttonStyle, styles[size], {
        [styles.borderLess]: borderless,
        [styles.mobile]: isMobile
      }),
      style,
      type: "button"
    },
    children
  );
};

export { Button as default };
//# sourceMappingURL=Button.js.map
